import { z } from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const imageSchema = surrealRecordSchema.extend({
  bytes: z.custom<ArrayBuffer>(),
  title: z.string(),
  order: z.number(),
});

export type Image = z.infer<typeof imageSchema>;
